const request = require("request");
require('babel-polyfill')

const urlShortner = async (url) => {
    let key = process.env.CUTTLY_API_KEY;
    let URL = process.env.CUTTLY_BASE_URL + "?key=" + key + "&short=" + url;
    var options = {
        method: "GET",
        url: URL,
        headers: {
            "Content-Type": "application/json",
            Accept: "*/*"
        },
        json: true,
    };
    
    return new Promise((resolve, reject) => {
        request(options, function (error, response) {
            if (error) reject(error);
            resolve(response);
        });
    });
}

module.exports = urlShortner;